module.exports = __webpack_public_path__ + "static/img/about_card01.dae65d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_card01.png
// module id = +Q78
// module chunks = 2